import { useState, useEffect } from 'react';
import useDataBean from '../../../../core/services/dataBean/useDataBean';
import { _Appointment, _single } from '../../../../core/services/dataBean/EntityCatalog';
import Select from 'react-select';

interface Props {
    idSelector: number;
    onChange: any;
    seeMoney?: boolean;
    label?: string;
    returnType?: "ID" | "Object";
}

export const AppointmentEditor = ({ idSelector, onChange, label, returnType, seeMoney }: Props) => {

    const { instance, bean, setBean, lista, setLista } = useDataBean(_Appointment)
    const [selectedOption, setSelectedOption] = useState<any>(null);


    useEffect(() => {
        getLista();
    }, []);

    useEffect(() => {
        if (idSelector && lista.length > 0) {
            const found = lista.find(item => item.DataBeanProperties.IDAppointment === idSelector);
            if (found) {
                setSelectedOption({
                    value: found.DataBeanProperties.IDAppointment,
                    label: found.DataBeanProperties.Name,
                    item: found
                });
            }
        }
    }, [idSelector, lista]);

    const getLista = () => {
        instance.getAppointmentCatalog().then(
            (resp) => {
                setLista(resp);
            }
        ).catch(err => { console.log(err) });
    };

    const handleChange = (option: any) => {
        setSelectedOption(option);
        if (!option) {
            if (onChange)
                onChange(returnType === "Object" ? {} : null);
        } else {

            if (onChange) {
                onChange(returnType === "Object" ? option.item.DataBeanProperties : option.value);
            }
        }
    };

    const options = lista.map((item: any) => ({
        value: item.DataBeanProperties.IDAppointment,
        label: item.DataBeanProperties.Name,
        item: item
    }));

    return (
        <>

            {label && label != " " &&
                < label > {label ?? "Nivel de Empleo"}</label>
            }
            <Select
                options={options}
                value={selectedOption}
                onChange={handleChange}
                isClearable
                placeholder="Selecciona Nivel Salarial..."
                noOptionsMessage={() => "Sin coincidencias"}
            />

            {seeMoney === true && selectedOption?.item?.DataBeanProperties?.Salary != null && (
                <>
                    <label>Salario</label>
                    <input
                        type="text"
                        className="form-control"
                        value={`$ ${_single.formatMoney(selectedOption.item.DataBeanProperties.Salary)}`}
                        disabled
                    />
                </>
            )}

        </>
    )
}
